<template>
  <v-dialog v-model="isActive" @keydown.esc="isActive = false" :max-width="maxWidth" scrollable>
    <v-card :color="backgroundColor" :dark="dark">
      <v-card-title class="title line-height-24 text-pre-line">{{ message }}</v-card-title>
      <v-card-text v-if="content" class="content text-pre-line" v-html="content"></v-card-text>
      <v-card-actions v-if="!isCustom">
        <v-spacer></v-spacer>
        <v-btn v-if="!alert" :color="color" flat @click="cancel">{{ cancelText }}</v-btn>
        <v-btn :flat="alert" :color="color" @click="confirm">{{ confirmText }}</v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-spacer></v-spacer>
        <v-btn v-for="(btn, index) in customBtns" :key="index" :color="btn.color || color" :flat="btn.flat"
               @click="() => {if (btn.click) btn.click(itemId); isActive = false}">
          {{ btn.text }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Toggleable from '@/mixins/toggleable'

export default {
    name: 'ConfirmDialog',
    mixins: [Toggleable],
    data () {
        return {
            itemId: null,
            message: '',
            confirmCallback: (id) => ({}),
            cancelCallback: (id) => ({}),
            cancelText: '',
            confirmText: '',
            color: '',
            backgroundColor: '',
            dark: false,
            alert: false,
            maxWidth: '450',
            content: null,
            isCustom: false,
            customBtns: []
        }
    },
    methods: {
        cancel () {
            this.cancelCallback(this.itemId)
            this.isActive = false
        },
        confirm () {
            this.confirmCallback(this.itemId)
            this.isActive = false
        },
        showAlert (message, options = {}) {
            this.isCustom = false
            this.alert = true
            this.message = message
            this.setOptions(options)
            this.isActive = true
        },
        show (itemId, message, onConfirmCallback, options = {}) {
            this.isCustom = false
            this.itemId = itemId
            this.message = message
            this.confirmCallback = onConfirmCallback
            this.setOptions(options)
            this.isActive = true
        },
        showCustom (itemId, message, options = {}) {
            this.isCustom = true
            this.itemId = itemId
            this.message = message
            this.setOptions(options)
            this.customBtns = options.btns || []
            this.isActive = true
        },
        setOptions (options) {
            //  Setto le opzioni aggiuntive
            this.cancelText = options.cancelText || this.$t('azioni.annulla')
            this.confirmText = options.confirmText || this.$t('azioni.conferma')
            this.color = options.color || 'accent'
            this.backgroundColor = options.backgroundColor || 'white'
            this.dark = options.dark || false
            this.maxWidth = options.maxWidth || '450'
            this.content = options.content || null
        }
    }
}
</script>
<style lang="scss" scoped>
  .content {
    padding-left: 32px !important;
  }
</style>
